import { render, staticRenderFns } from "./daftarkirimangratis.vue?vue&type=template&id=62a2553f"
import script from "./daftarkirimangratis.vue?vue&type=script&lang=js"
export * from "./daftarkirimangratis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports